import React, { useEffect, useState } from "react";
import {
  calculateDateRangeFromDate,
  roundOffValue,
  roundToTwoDecimalPlaces,
} from "../../../../../../Utils/DateConverstion";
import { Button, Modal, Card } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import Empty from "../../../../../CommonScreens/Empty";

const getModulePath = (path) => {
  console.log(path);
  // if (path.includes("steam-dashboard")) return "steam-dashboard";
  if (path.includes("electrical-dashboard")) return "electrical-dashboard";
  // if (path.includes("temperature-dashboard")) return "temperature-dashboard";
  // if (path.includes("air-dashboard")) return "air-dashboard";
  // if (path.includes("water-dashboard")) return "water-dashboard";
  return "";
};


export const ElectricalMeterGrid = ({sectionId, report, selected, setSelected ,converterGroupId,open,setOpen}) => {
  const navigate = useNavigate();
  const { makeRequest } = useStoreUpdaterWithAPI(); 
  const location = useLocation();
  const [selectedReport, setSelectedReport] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedParameters, setSelectedParameters] = useState([
    "VR",
    "VB",
    "F",
    "VY",
    "VRY",
    "VYB",
    "VBR",
    "VLLAvg",
    "IR",
    "IY",
    "IB",
    "IAVG",
    "Vunb",
    "Iunb",
    "KWT",
    "KVAT",
    "KVART",
    "PFT",
    "PFR",
    "PFB",
    "KWR",
    "KWY",
    "KWB",
    "KVA_R",
    "KVA_Y",
    "KVA_B",
    "KVAR_Y",
    "KVAR_B",
    "KWD",
    "KVAD",
    "KWHTotal",
    "kWhImport",
    "KWHEXPORT",
    "kVAh",
    "kVArhTotal",
    "kVArhinductive",
    "KVARHCAPACITIVE",
    "V_THDAvg",
    "V_THDR",
    "V_THDY",
    "V_THDB",
    "I_THDAvg",
    "I_THDR",
    "I_THDY",
    "I_THDB",
  ]);
  const modulePath = getModulePath(location.pathname);
  const [selectedValues, setSelectedValues] = useState(["IAVG"]);
  const [parameters, setParameters] = useState([]);
  const [title, setTitle] = useState('Title')
  function extractSiteNameAndMeterId(data) {
    console.log(data)
    const currentDate = new Date();
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    return {
      SectionID: sectionId,
      ConverterorGroupID: converterGroupId,
      SiteName: data.SiteName,
      MeterIds: sectionId ==1? data.MeterId:data.AutoID,
      FromDate: from,
      ToDate: to,
    };
  }
  const showModal = (item) => {
    console.log(item);
    fetchparamters(extractSiteNameAndMeterId(item));
    const paraData = extractSiteNameAndMeterId(item);
    console.log("first");
    console.log(paraData);
    setSelectedReport(paraData);
    setIsModalVisible(true);
    // navigate(`/${modulePath}/meter-status/meter-status-popup`);
  };

  const handleCancel = () => {
    setSelectedReport(null);
    setIsModalVisible(false);
    // navigate(`/${modulePath}/meter-status`);
  };
  console.log(report);
  console.log(converterGroupId);

  // useEffect(()=>{
  //     setSelected(!selected);
  // },[report])

  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const filteredReport =
  report && Array.isArray(report)
    ? report.map((item) => {
        const filteredItem = {};
        let status = "idle"; // Default status is "off"

        // Loop through selectedParameters to filter parameters
        selectedParameters.forEach((param) => {
          // Check if the parameter exists in the item and apply conditions for "IAVG"
          if (
            item[param] !== undefined &&
            (param !== "IAVG" || selectedValues.includes("IAVG"))
          ) {
            filteredItem[param] = item[param];
          }
        });

        // Determine the status based on IAVG and kWh total
        const MeterStatus = item["MeterStatus"] || 0; // Default to 0 if IAVG is undefined
        const kWhImport = item["kWhImport"] || 0; // Default to 0 if kWh total is undefined
        const KWHTotal = item["KWHTotal"] || 0; // Default to 0 if kWh total is undefined

        if (MeterStatus=="OFF") {
          status = "off"; // Both IAVG and kWh total are zero -> "off"
        } else if (MeterStatus === "idle") {
          status = "idle"; // IAVG has a value but kWh total is zero -> "idle"
        } else if (MeterStatus==="ON") {
          status = "on"; // Both IAVG and kWh total have values -> "on"
        }
        // if (iavg === 0 && kWhImport === 0&& KWHTotal === 0) {
        //   status = "off"; // Both IAVG and kWh total are zero -> "off"
        // } else if (iavg > 0 && kWhImport === 0 && KWHTotal === 0) {
        //   status = "idle"; // IAVG has a value but kWh total is zero -> "idle"
        // } else if (iavg >= 0 && (kWhImport > 0 || KWHTotal > 0)) {
        //   status = "on"; // Both IAVG and kWh total have values -> "on"
        // }

        // Return the transformed item with the additional status
        return { ...item, parameters: filteredItem, status };
      })
    : [];


  console.log(report);



  const getParameterDisplay = (paramValue) => {
    if (paramValue > 0) {
      return { display: `${roundOffValue(paramValue)}`, borderColor: "green" };
    } else if (paramValue === 0) {
      return { display: `${roundOffValue(paramValue)}`, borderColor: "yellow" };
    } else if (paramValue < 0) {
      return {
        display: `${roundOffValue(paramValue)}`,
        borderColor: "#f44336",
      };
    } else {
      return { display: `${roundOffValue(paramValue)}`, borderColor: "yellow" };
    }
  };
  console.log(selectedReport);

  const fetchparamters = (input) => {
    // setIsLoading(true);
    console.log(input);
    const url = `${APIConstants.ELECTRICAL_PARAMETER_VIEW}?SectionID=${input.SectionID}&ConverterorGroupID=${input.ConverterorGroupID}&MeterIds=${input.MeterIds}&FromDate=${input.FromDate}&Todate=${input.ToDate}`;
    console.log("URL :", url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
    })
      .then((res) => {
        console.log("Meter Data:", res);
        console.log(extractKeyValuePairs(res))
        setParameters(extractKeyValuePairs(res));
        setTitle(res)
      })
      .catch((error) => {
        console.error("Error fetching meter data:", error);
      });
  };

  const mapResponse = (responseArray) => {
    // Helper function to find parameter value by name
    console.log(responseArray)
    const getValue = (name) => {
      const parameter = responseArray.find(item => item.parametername.toLowerCase() === name.toLowerCase());
      return parameter ? parameter.value : 0;
    };
  
    // Map the response to the required format
    return {
      KWH: getValue('kwhTotal'),
      PF: getValue('pft'),
      VLL: getValue('vllAvg'),
      IAvg: getValue('iavg'),
      meterId: getValue('meterId'), // Assuming a static meter ID for now
      VRY: getValue('vry'),
      VYB: getValue('vyb'),
      VBR: getValue('vbr'),
      avgVLL: getValue('vllAvg'),
      kVA1: getValue('kvA_R'),
      kVA2: getValue('kvA_Y'),
      kVA3: getValue('kvA_B'),
      kVAT: getValue('kvat'),
      kW1: getValue('kwr'),
      kW2: getValue('kwy'),
      kW3: getValue('kwb'),
      kWT: getValue('kwt'),
      kVAR1: getValue('kvaR_R'),
      kVAR2: getValue('kvaR_Y'),
      kVAR3: getValue('kvaR_B'),
      kVART: getValue('kvart'),
      VR: getValue('vr'),
      VY: getValue('vy'),
      VB: getValue('vb'),
      I1: getValue('ir'),
      I2: getValue('iy'),
      I3: getValue('ib'),
      KWh: getValue('kwhTotal'),
      KVAh: getValue('kVAh'),
      KVARhTotal: getValue('kVArhTotal'),
      KWHEXPORT: getValue('kwhexport'),
      lastPollTime: new Date().toLocaleString(), // Placeholder for current time
    };
  };
  const extractKeyValuePairs = (data) => {
    // Destructure the first object in data
    const dataObject = data["0"];
    console.log(data)

    // List of keys to exclude
    const excludeKeys = ["siteName", "metername","createdOn"];

    // Create an array of objects with key-value pairs
    const keyValuePairs = Object.keys(dataObject)
      .filter((key) => !excludeKeys.includes(key)) // Exclude the keys that are in excludeKeys
      .map((key) => ({
        parametername: key, // Using the key as the parametername
        value: dataObject[key], // The corresponding value for that key
      }));

      const res = mapResponse(keyValuePairs)
    return res;
  };

  console.log(selectedParameters)

  const data = {
    KWH: 11158.8,
    PF: 1,
    VLL: 189.24,
    IAvg: 0,
    meterId: 1,
    VRY: 283.08,
    VYB: 0,
    VBR: 284.65,
    avgVLL: 189.24,
    kVA1: 0,
    kVA2: 0,
    kVA3: 0,
    kVAT: 0,
    kW1: 0,
    kW2: 0,
    kW3: 0,
    kWT: 0,
    kVAR1: 0,
    kVAR2: 0,
    kVAR3: 0,
    kVART: 0,
    VR: 230.96,
    VY: 82.32,
    VB: 82.31,
    I1: 0,
    I2: 0,
    I3: 0,
    KWh: 11158.8,
    KVAh: 13715.37,
    KVARhTotal: 8603.731,
    KWHEXPORT: -7144.18,
    lastPollTime: '12/26/2024 9:28:00 AM',
  };
  console.log(parameters)
  console.log(filteredReport);
   const color = useSelector((state) => state.ThemeChange);
      console.log(color)

  const parameterCategories = [
    {
      title: "Main Parameters",
      data: [
        { label: "KWH", value: parameters.KWH },
        { label: "PF", value: parameters.PF },
        { label: "V LL", value: parameters.VLL },
        { label: "I Avg", value: parameters.IAvg },
      ],
    },
    {
      title: "Voltage Line to Line",
      data: [
        { label: "VRY", value: parameters.VRY },
        { label: "VYB", value: parameters.VYB },
        { label: "VBR", value: parameters.VBR },
        { label: "Avg VLL", value: parameters.avgVLL },
      ],
    },
    {
      title: "Apparent Power",
      data: [
        { label: "kVA1", value: parameters.kVA1 },
        { label: "kVA2", value: parameters.kVA2 },
        { label: "kVA3", value: parameters.kVA3 },
        { label: "kVAT", value: parameters.kVAT },
      ],
    },
    {
      title: "Active Power",
      data: [
        { label: "kW1", value: parameters.kW1 },
        { label: "kW2", value: parameters.kW2 },
        { label: "kW3", value: parameters.kW3 },
        { label: "kWT", value: parameters.kWT },
      ],
    },
    {
      title: "Reactive Power",
      data: [
        { label: "kVAR1", value: parameters.kVAR1 },
        { label: "kVAR2", value: parameters.kVAR2 },
        { label: "kVAR3", value: parameters.kVAR3 },
        { label: "kVART", value: parameters.kVART },
      ],
    },
    {
      title: "Voltage",
      data: [
        { label: "VR", value: parameters.VR },
        { label: "VY", value: parameters.VY },
        { label: "VB", value: parameters.VB },
      ],
    },
    {
      title: "Current",
      data: [
        { label: "I1", value: parameters.I1 },
        { label: "I2", value: parameters.I2 },
        { label: "I3", value: parameters.I3 },
        { label: "I Avg", value: parameters.IAvg },
      ],
    },
    {
      title: "Energies",
      data: [
        { label: "KWh", value: parameters.KWh },
        { label: "KVAh", value: parameters.KVAh },
        { label: "KVARh Total", value: parameters.KVARhTotal },
        { label: "KWHEXPORT", value: parameters.KWHEXPORT },
      ],
    },
  ];


  return (  
    <div className={`flex px-2 py-0 flex-wrap w-full gap-3 rounded-md`}>
      {filteredReport.length === 0 ? (
        <div className={`${!isdarkMode ? "text-black " : "text-white "} text-center w-full`}
        >
          <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
        </div>
      ) : (
        filteredReport.map((item) => {
          return (
            <Card
              key={item?.MeterId}
              onClick={() => showModal(item)}
              className={`min-w-[250px] my-1 mx-1 rounded-md text-center shadow-2xl ${isdarkMode ? "ant-card-background " : "whitemode"}`}
              headStyle={{
                backgroundColor:`${item.status==='off'?"red":item.status==='on'?"green":item.status==='idle'?'yellow':''}`,
              }}
              title={
                <p
                  className="py-2 h-auto font-bold"
                  style={{
                    backgroundColor: `${item.status==='off'?"red":item.status==='on'?"green":item.status==='idle'?'yellow':''}`,
                    margin: 0,
                    padding: "5px 0",
                  }}
                >
                  {item?.METERNAME}
                </p>
              }
            >
              <p
                className={`h-auto pb-5 font-bold text-black ${isdarkMode ? "ant-card-body-padding" : "whitemode"}`}
                style={{
                  borderBottomWidth: "2px",
                  borderBottom: `${item.status==='off'?" 2px solid red":item.status==='on'?"2px solid green":item.status==='idle'?'2px solid yellow':''}`,
                  // borderBottom: `2px solid ${borderColor}`,
                }}
              >
                Meter ID: {roundToTwoDecimalPlaces(item?.MeterId)}
              </p>

              <div
                className={`space-y-3 h-auto font-bold text-black ${isdarkMode ? "ant-card-body-padding" : "whitemode"}`}
              >
                {Object.keys(item.parameters).map((paramKey) => {
                  if (
                    paramKey !== "IAVG" ||
                    (paramKey === "IAVG" && selected)
                  ) {
                    const paramValue = item.parameters[paramKey];
                    return (
                      <p
                        key={paramKey}
                        className="border-b-2 my-3 h-auto pb-2 w-full"
                        style={{
                          borderBottomWidth: "2px",
                          borderBottom: `${item.status==='off'?" 2px solid red":item.status==='on'?"2px solid green":item.status==='idle'?'2px solid yellow':''}`,
                        }}
                      >
                        {paramKey} : {roundOffValue(paramValue)}
                      </p>
                    );
                  }
                  return null;
                })}
              </div>
            </Card>
          );
        })
      )}

<Modal
  open={isModalVisible}
  onCancel={handleCancel} 
  closable={false}
  // className={`custom-modal custom-card ${isdarkMode ? "custom-modal-dark" : "whitemode"}`}
  className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
  footer={null}
  width={1100}
  style={{  textAlign: "center" }} // Adjust 'top' to set vertical position
  bodyStyle={{ textAlign: "center" }} // Center the content
  // title={
  // }
>
    <div
      style={{
        padding: 5,
        paddingTop:10,
        borderRadius: "8px 8px 0 0",
        backgroundColor: color.themeConfig.colorPrimary
      }}
      className={`gap-3 text-lg  flex justify-between items-center text-white `}
      // className={`gap-3  flex justify-between items-center ${
      //   isdarkMode ? "text-white bg-[#1F2A40]" : "text-black bg-slate-400 "
      // }`}
    >
      <p
        className={`border-b-2 px-2 border-blue-500 ${
          isdarkMode ? "text-white" : "text-white"
        }`}
      >
      Meter ID : {parameters.meterId||"N/A"}
      </p>
      <p className="text-center">
        {title[0]?.metername || "N/A"}
      </p>
      <p>
        Last Poll Time: {title[0]?.createdOn?.replace("T", " ") || "N/A"}
      </p>
    </div>
  <div
    className={`text-center font-bold ${
      isdarkMode ? "text-white" : "text-white border-2 rounded-md"
    }`}
  >


<Card
      className={`custom-card  rounded-lg shadow-lg p-0 ${
        isdarkMode ? "bg-[#1F2A40] text-white" : "bg-white text-black"
      }`}
    >
      <div className="dashboard">
        <div className="content grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {parameterCategories.map((category, index) => (
            <div
              key={index}
              className={`box p-3 rounded-2xl shadow-xl ${
                isdarkMode ? "bg-gray-700 text-white" : "bg-[#1a1a3d] text-white"
              }`}  
            >
              <h3 className="text-lg font-semibold text-center mb-2">
                {category.title}
              </h3>
              {category.data.map((item, i) => (
                <div key={i} className="grid grid-cols-3 text-center py-1 gap-0 pl-4">
                  <p className="text-left w-28">{item.label}</p>
                  <p className="text-center">:</p>
                  <p className="text-left">{item.value || "0"}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Card>
  </div>

  <div className="flex w-full justify-end mt-5">
    <Button 
     type='primary'
      className="mr-5 mb-5  text-white rounded-md "
      onClick={handleCancel}
    >
      Close
    </Button>
  </div>
</Modal>

    </div>
  );
};

